import { useCallback } from "react";

import { useAppDispatch, useAppSelector } from "@/store";
import { switchTenant, type Tenant } from "@/store/slices/tenant";

/**
 * Redux-backed tenant hook — replacement for the old context provider.
 * Multi-property switching (ARCHITECTURE.md §7) is wired but only one tenant
 * is seeded for Phase 1.
 */
export function useTenant() {
  const dispatch = useAppDispatch();
  const tenant = useAppSelector((s) => s.tenant.current);
  const available = useAppSelector((s) => s.tenant.available);

  const setTenant = useCallback(
    (id: string) => dispatch(switchTenant(id)),
    [dispatch],
  );

  return { tenant, available, setTenant };
}

export type { Tenant };
